"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useElementSize = useElementSize;
const react_1 = require("react");
const useEventListener_1 = require("./useEventListener");
const useIsomorphicLayoutEffect_1 = require("./useIsomorphicLayoutEffect");
function useElementSize(includePadding = false) {
    // Mutable values like 'ref.current' aren't valid dependencies
    // because mutating them doesn't re-render the component.
    // Instead, we use a state as a ref to be reactive.
    const [ref, setRef] = (0, react_1.useState)(null);
    const [size, setSize] = (0, react_1.useState)({
        width: 0,
        height: 0,
    });
    // Prevent too many rendering using useCallback
    const handleSize = (0, react_1.useCallback)(() => {
        const computedStyle = ref ? getComputedStyle(ref) : null;
        const xPadding = computedStyle
            ? parseFloat(computedStyle.paddingLeft) + parseFloat(computedStyle.paddingRight)
            : 0;
        const yPadding = computedStyle
            ? parseFloat(computedStyle.paddingTop) + parseFloat(computedStyle.paddingBottom)
            : 0;
        const elementWidth = (ref === null || ref === void 0 ? void 0 : ref.offsetWidth) || 0;
        const elementHeight = (ref === null || ref === void 0 ? void 0 : ref.offsetHeight) || 0;
        setSize({
            width: includePadding ? elementWidth - xPadding : elementWidth,
            height: includePadding ? elementHeight - yPadding : elementHeight,
            boundingClientRect: ref === null || ref === void 0 ? void 0 : ref.getBoundingClientRect(),
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [ref === null || ref === void 0 ? void 0 : ref.offsetHeight, ref === null || ref === void 0 ? void 0 : ref.offsetWidth]);
    (0, useEventListener_1.useEventListener)('resize', handleSize);
    (0, useIsomorphicLayoutEffect_1.useIsomorphicLayoutEffect)(() => {
        handleSize();
    }, [ref === null || ref === void 0 ? void 0 : ref.offsetHeight, ref === null || ref === void 0 ? void 0 : ref.offsetWidth]);
    return [setRef, size];
}
